export function calculatePercentageAmount(total: number, percentage: number) {
    const p = Number(percentage.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    }));

    return (total * p) / 100;
}